<template>
    <b-overlay :show="formLoader">
        <b-container fluid>
            <b-row>
                <b-col lg="12" sm="12">
                    <template>
                        <b-row>
                            <b-col lg="12" sm="12">
                                <b-row style="padding-left:5px">
                                    <b-col lg="7" sm="7">
                                        <div class="text-dark font-weight-bold w-25 float-left">{{ $t('globalTrans.fiscal_year') }}</div>
                                        <div class="text-dark">: {{ getFiscalYear(formData.fiscal_year_id) }}</div>
                                    </b-col>
                                    <b-col lg="5" sm="5">
                                        <div class="text-dark font-weight-bold w-25 float-left">{{ $t('tp_management.circular_no') }}</div>
                                        <div class="text-dark">: {{ getCircularName(formData.circular_id) }}</div>
                                    </b-col>
                                    <b-col lg="7" sm="7">
                                        <div class="text-dark font-weight-bold w-25 float-left">{{ $t('elearning_config.training') }}</div>
                                        <div class="text-dark">: {{ getTrainingName(formData.training_name_id) }}</div>
                                    </b-col>
                                    <b-col lg="5" sm="5">
                                        <div class="text-dark font-weight-bold w-25 float-left">{{ $t('trainer_trainee.batch') }}</div>
                                        <div class="text-dark">: {{ getBatchName(formData.batch_id) }}</div>
                                    </b-col>
                                    <b-col lg="7" sm="7">
                                        <div class="text-dark font-weight-bold w-25 float-left">{{ $t('trainer_trainee.trainee') }}</div>
                                        <div class="text-dark">: {{ $i18n.locale === 'en' ? formData.trainee.name : formData.trainee.name_bn }}</div>
                                    </b-col>
                                    <b-col lg="5" sm="5">
                                        <div class="text-dark font-weight-bold w-25 float-left">{{ $t('globalTrans.remarks') }}</div>
                                        <div class="text-dark">: {{ formData.remarks }}</div>
                                    </b-col>
                                    <b-col lg="7" sm="7">
                                        <div class="text-dark font-weight-bold w-25 float-left">{{$t('globalTrans.date')}}</div>
                                        <div class="text-dark">: {{ formData.created_at | dateFormat }}</div>
                                    </b-col>
                                </b-row>
                                <b-row class="mt-2">
                                    <b-col lg="12" sm="12">
                                        <b-table-simple class="tg mt-3" bordered hover small caption-top responsive>
                                            <b-tbody>
                                                <span hidden>{{ $total = 0 }}</span>
                                                <tr>
                                                    <th style="width:15%">{{$t('trainer_trainee.trainers') + ' ' + $t('globalTrans.name')}}</th>
                                                    <th style="width:15%">{{$t('tp_management.course')}}</th>
                                                    <th class="text-center" style="width:20%" v-for="(item, index) in  formData.trainers[0].details" :key="index">{{ getEvaluationName(item.eva_subject_id) }}</th>
                                                    <th class="text-center" style="width:15%">{{$t('globalTrans.total')}}</th>
                                                </tr>
                                                <tr v-for="(trainer, index) in formData.trainers" :key="index">
                                                    <b-td  class="text-left">{{ $i18n.locale === 'en' ? trainer.trainer.name : trainer.trainer.name_bn }}</b-td>
                                                    <b-td class="text-left">{{ $i18n.locale === 'en' ? trainer.course.name : trainer.course.name_bn }}</b-td>
                                                    <b-td class="text-center" v-for="(detail, inex) in  trainer.details" :key="inex">
                                                        {{ $n(detail.marks) }}
                                                    </b-td>
                                                    <b-td class="text-center">{{ $n(totalMarks(trainer.details), { useGrouping: false }) }}</b-td>
                                                </tr>
                                                <tr>
                                                  <b-td :colspan="formData.trainers[0].details.length + 2" class="text-right">{{$t('trainer_trainee.grand') + ' ' + $t('globalTrans.total') + ' : ' }}</b-td>
                                                  <b-td>{{$n(totalGrandMarks(formData.trainers), { useGrouping: false }) }}</b-td>
                                                </tr>
                                            </b-tbody>
                                        </b-table-simple>
                                        <div class="row">
                                            <div class="col-sm-3"></div>
                                            <div class="col text-right">
                                                <b-button variant="danger" class="mr-1" @click="$bvModal.hide('modal-2')">{{ $t('globalTrans.close') }}</b-button>
                                            </div>
                                        </div>
                                    </b-col>
                                </b-row>
                            </b-col>
                        </b-row>
                    </template>
                </b-col>
            </b-row>
        </b-container>
    </b-overlay>
</template>

<script>
import { core } from '@/config/pluginInit'

export default {
    name: 'Details',
    props: ['id'],
    data () {
        return {
            formLoader: false,
            formData: {},
            marksData: []
        }
    },
    created () {
        if (this.id) {
            const tmp = this.getData()
            this.formData = tmp
        }
    },
    computed: {
    },
    mounted () {
        core.index()
    },
    methods: {
      totalMarks (data) {
       const sum = data.reduce(function (s, a) {
          return s + a.marks
        }, 0)
        return sum
      },
      totalGrandMarks (data) {
        let sum = 0
        data.forEach((element, index) => {
          sum += this.totalMarks(element.details)
        })
        return sum
      },
        EngBangNum (n) {
            if (this.$i18n.locale === 'bn') {
                return n.replace(/\d/g, d => '০১২৩৪৫৬৭৮৯'[d])
            } else {
                return n.replace(/[০-৯]/g, d => '০১২৩৪৫৬৭৮৯'.indexOf(d))
            }
        },
        tConvert (time) {
            // Check correct time format and split into components
            time = time
                .toString()
                .match(/^([01]\d|2[0-3])(:)([0-5]\d)(:[0-5]\d)?$/) || [time]
            if (time.length > 1) {
                time = time.slice(1)
                time[5] = +time[0] < 12 ? ' ' + this.$t('ds_exam_management.am') : ' ' + this.$t('ds_exam_management.pm')
                time[0] = +time[0] % 12 || 12
            }
            return time.join('')
        },
        getData () {
            const tmpData = this.$store.state.list.find(item => item.id === this.id)
            return JSON.parse(JSON.stringify(tmpData))
        },
        getCircularName (id) {
            const obj = this.$store.state.TrainingElearning.commonObj.circularMemoList.find(item => item.value === id)
            if (this.$i18n.locale === 'bn') {
                return obj.text_bn
            } else {
                return obj.text
            }
        },
        getFiscalYear (id) {
            const obj = this.$store.state.commonObj.fiscalYearList.find(item => item.value === id)
            if (this.$i18n.locale === 'bn') {
                return obj.text_bn
            } else {
                return obj.text
            }
        },
        getTrainingName (id) {
            const obj = this.$store.state.TrainingElearning.commonObj.trainingNameList.find(item => item.value === id)
            if (this.$i18n.locale === 'bn') {
                return obj.text_bn
            } else {
                return obj.text
            }
        },
        getBatchName (id) {
            const obj = this.$store.state.TrainingElearning.commonObj.batchList.find(item => item.value === id)
            if (this.$i18n.locale === 'bn') {
                return obj.text_bn
            } else {
                return obj.text
            }
        },
        getEvaluationName (id) {
            const obj = this.$store.state.TrainingElearning.commonObj.evaluationNameList.find(item => item.value === id)
            if (this.$i18n.locale === 'bn') {
                return obj.text_bn
            } else {
                return obj.text
            }
        }
    }
}
</script>
